import { SystemRole } from 'modules/shared/roles';

// Define path names here
export enum RoutePaths {
    Home = 'home',
    Login = 'login',
    Profile = 'profile',
    Reports = 'reports',
    Search = 'search',
    UserManagement = 'usermanagement',
    SchoolImport = 'schoolimport',
    Classlink = 'classlink',
    Classlink2 = 'classlink ',
}

// Define the roles which have access to each route listed above.
export const RouteRoles = {
    Home: [SystemRole.All],
    Login: [SystemRole.All],
    Profile: [SystemRole.All],
    Reports: [
        SystemRole.Developer,
        SystemRole.SystemAdmin,
        SystemRole.DistrictAdmin,
        SystemRole.Regional,
        SystemRole.PrincipalUpdater,
    ],
    Search: [SystemRole.Developer, SystemRole.SystemAdmin, SystemRole.DistrictAdmin, SystemRole.Regional, SystemRole.PrincipalUpdater],
    UserManagement: [SystemRole.Developer, SystemRole.SystemAdmin],
    SchoolImport: [SystemRole.Developer, SystemRole.SystemAdmin, SystemRole.AAEAdmin],
    Classlink: [SystemRole.All],
};
